export const getInfoFromParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const data: any = {};
    urlParams.forEach((value, key) => {
        if (key.startsWith(`mh-`)) {
            data[key.slice(3).replace(`-`, `_`)] = value;
        }
    });

    return data;
};
